// <shipping-bar> — multi-tier free-shipping progress bar.
// All state (text, milestone reached/unreached, target width) is computed in Liquid and
// re-rendered through the Section Rendering API on every cart change. This component only
// animates the fill from 0 to its data-progress target each time it is (re)rendered.
if (!customElements.get('shipping-bar')) {
  class ShippingBar extends HTMLElement {
    connectedCallback() {
      const fill = this.querySelector('[data-progress-line]');
      if (!fill) return;
      const target = this.getAttribute('data-progress') || '0%';
      // next frame so the transition runs from 0
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          fill.style.width = target;
        });
      });
    }
  }
  customElements.define('shipping-bar', ShippingBar);
}
